// Sub-event email templates we track per-recipient (who got the email).
// Used by TicketManagement to update flyer.subEventEmailStatus and show "Emailed" in the table.
export const TRACKED_SUB_EVENT_CAMPAIGNS = [
  {
    label: 'After Party',
    templateKey: 'after_party_desc_budget',
    statusField: 'afterPartyDescBudgetSentAt',
  },
  // Add more as needed, e.g.:
  // { label: 'Water Training (Thur)', templateKey: 'water_training_thur', statusField: 'waterTrainingThurSentAt' },
  // { label: 'Canopy Thursday', templateKey: 'canopy_thursday', statusField: 'canopyThursdaySentAt' },
];

export function getTrackedCampaignForSubEvent(subEventLabel, templateKey) {
  return TRACKED_SUB_EVENT_CAMPAIGNS.find(
    (c) => c.label === subEventLabel && c.templateKey === templateKey
  );
}
